import getApi from '../tools/api/progress';

const api = getApi({ isMock: false });

export default {
    namespaced: true,

    state: () => ({
        pageType: null,
        category: null,
        profession: null,
        professionSpecializations: [],
        professionPrograms: [],
        professionProgramsTotal: null,
        specialization: null,
    }),
    mutations: {
        setPageType: (state, type) => state.pageType = type,
        setCategory: (state, category) => state.category = category,
        setProfession: (state, profession) => state.profession = profession,
        setProfessionSpecializations: (state, specializations) => state.professionSpecializations = specializations,
        setProfessionPrograms: (state, programs) => state.professionPrograms = programs,
        setProfessionProgramsTotal: (state, programsTotal) => state.professionProgramsTotal = programsTotal,
        setSpecialization: (state, specialization) => state.specialization = specialization,
    },
    actions: {
        async setPageType(ctx, pageType) {
            ctx.commit('setPageType', pageType);
            ctx.commit('setCategory', null);
            ctx.commit('setProfession', null);
            ctx.commit('setSpecialization', null);
        },
        async loadCategory(ctx, id) {
            let item = await api.fetchCategory(id);
            ctx.commit('setCategory', item);
        },
        async loadProfession(ctx, id) {
            let item = await api.fetchProfession(id);
            ctx.commit('setProfession', item && item.entityType === 'profession' ? item : null);
        },
        async loadProfessionPrograms(ctx, { professionId, limit, offset, filter = {} }) {
            const res = await api.fetchProfessionPrograms(professionId, { limit, offset, filter });

            if (res) {
                const items = res.items;
                const total = res.total;
                ctx.commit('setProfessionPrograms', items && items.length ? items : []);
                ctx.commit('setProfessionProgramsTotal', total ? total : 0);
            }
        },
        async loadSpecialization(ctx, id) {
            let item = await api.fetchProfession(id);
            ctx.commit('setSpecialization', item && item.entityType === 'specialization' ? item : null);
        },
        
        async loadSpecializationsBulk(ctx, ids) {
            let items = await api.fetchSpecializationsBulk(ids);
            ctx.commit('setProfessionSpecializations', items);
            return items;
        },
    },
    getters: {
        getCategory: state => state.category,
        getProfession: state => state.profession,
        getSpecialization: state => state.specialization,
        getPagePublication: state => {
            if (state.pageType !== null && state[state.pageType] !== null) {
                return state[state.pageType];
            }
        },
        getProfessionSpecializationIds: state => {
            if (state.pageType !== 'profession' || !state.profession || !state.profession.specializations) {
                return [];
            }
            return state.profession.specializations;
        },
        getProfessionSpecializations: state => state.professionSpecializations,
        getProfessionPrograms: state => state.professionPrograms,
        getProfessionProgramsTotal: state => state.professionProgramsTotal,
        getOtherSpecializationIds: state => {
            if (state.pageType !== 'specialization' ||
                !state.specialization ||
                !state.specialization.adjacentSpecializations ||
                !state.specialization.adjacentSpecializations.length) {
                return [];
            }
            return state.specialization.adjacentSpecializations.filter(v => v.id !== state.specialization.id);
        },
    },
};
